import { Icon } from '@iconify/react';

const icon = (iconName) => <Icon icon={iconName} width={20} height={20} />;

const superAdminNavConfig = [
  {
    title: 'dashboard',
    path: '/super-admin',
    icon: icon('solar:widget-5-bold-duotone'),
  },
  {
    title: 'admins',
    path: '/super-admin/admins',
    icon: icon('mdi:domain'),
  },
  {
    title: 'packages',
    path: '/super-admin/packages',
    icon: icon('mdi:package-variant-closed'),
  },
  {
    title: 'payments',
    path: '/super-admin/payments',
    icon: icon('mdi:cash-multiple'),
  },
  {
    title: 'users',
    path: '/super-admin/users',
    icon: icon('mdi:account-group'),
  },
  {
    title: 'courier partners',
    path: '/super-admin/courier-partners',
    icon: icon('mdi:truck-fast'),
  },
];

export default superAdminNavConfig;
